/**
 * CONSENT-01 (868kmgf87) — el estado vigente, para los gates.
 *
 * VOTE-08 CA-02 lo evalúa AL MOMENTO DE EMITIR el voto, no al abrir la
 * votación, para que quien consienta a media votación pueda votar. Por eso esto
 * es una consulta corriente y no algo cacheado al montar la pantalla.
 */

import { useQuery } from '@tanstack/react-query';
import { CONSENT_ENDPOINT, fetchConsentState } from '../api/consent.api';
import type { ConsentScope, ConsentState, ConsentType } from '../types/consent.types';

/** El alcance va en la clave: el consentimiento de una propiedad no es el de otra. */
export function useConsentState(consentType: ConsentType, scope?: ConsentScope) {
  return useQuery<ConsentState>({
    queryKey: [CONSENT_ENDPOINT, consentType, 'state', scope?.propertyId ?? null, scope?.companyId ?? null],
    queryFn: () => fetchConsentState(consentType, scope),
  });
}
